export default "__VITE_ASSET__eca19103__"